const USER_SCOPE_SESSION_KEY = 'currentUserScopeId'

const isBrowser = () => typeof window !== 'undefined'

const getCurrentScopeKey = (key: string, scopeId: string | null) =>
  scopeId ? `u:${scopeId}:${key}` : key

export const getCurrentUserScope = (): string | null => {
  if (!isBrowser()) return null
  try {
    return window.sessionStorage.getItem(USER_SCOPE_SESSION_KEY)
  } catch {
    return null
  }
}

export const setCurrentUserScope = (scopeId: string | null) => {
  if (!isBrowser()) return
  try {
    if (scopeId) {
      window.sessionStorage.setItem(USER_SCOPE_SESSION_KEY, scopeId)
    } else {
      window.sessionStorage.removeItem(USER_SCOPE_SESSION_KEY)
    }
  } catch {
    // no-op
  }
}

export const getUserScopedItem = (key: string): string | null => {
  if (!isBrowser()) return null
  try {
    const scopeId = getCurrentUserScope()
    const scopedKey = getCurrentScopeKey(key, scopeId)
    const scopedValue = window.localStorage.getItem(scopedKey)
    if (scopedValue !== null) return scopedValue

    const legacyValue = window.localStorage.getItem(key)
    if (legacyValue !== null && scopeId) {
      window.localStorage.setItem(scopedKey, legacyValue)
    }
    return legacyValue
  } catch {
    return null
  }
}

export const setUserScopedItem = (key: string, value: string) => {
  if (!isBrowser()) return
  try {
    const scopeId = getCurrentUserScope()
    const scopedKey = getCurrentScopeKey(key, scopeId)
    window.localStorage.setItem(scopedKey, value)
  } catch {
    // no-op
  }
}

export const removeUserScopedItem = (key: string) => {
  if (!isBrowser()) return
  try {
    const scopeId = getCurrentUserScope()
    const scopedKey = getCurrentScopeKey(key, scopeId)
    window.localStorage.removeItem(scopedKey)
    window.localStorage.removeItem(key)
  } catch {
    // no-op
  }
}
